<template>
  <button class="dark">
    <slot>Default</slot>
  </button>
</template>

<script>
export default {};
</script>
